import { useTelemetryContext } from "@smb/web-telemetry";
import React, { useEffect, useMemo } from "react";

import { useGetAriaIngestionKeyQuery } from "../../graphql/graphql";

export const InstrumentationKeyProvider: React.FC<React.PropsWithChildren<any>> = ({
  children,
}) => {
  const { data } = useGetAriaIngestionKeyQuery();
  const { setTelementryIngestionKey } = useTelemetryContext();

  const instrumentationKey = useMemo(
    () => data?.getAriaIngestionKey ?? undefined,
    [data]
  );
  useEffect(() => {
    setTelementryIngestionKey(instrumentationKey);
  }, [instrumentationKey, setTelementryIngestionKey]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
